module.exports = __webpack_public_path__ + "img/icon_close_w.32935075.svg";